<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <div class="container">
        <div class="tw-grid tw-grid-cols-4 tw-gap-8">
          <PortalCompanyNavigation :company="company.data" :portal-company="portalCompany"/>

          <div class="tw-col-span-3">
            <router-view
                :company="company.data"
                :portal-company="portalCompany"
                :countries="countries"
                :users="users"
                @updated="portalCompany = $event"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import Errors from '@/mixins/Errors'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import PortalCompanyNavigation from "./PortalCompanyNavigation.vue";

export default {
  components: {PortalCompanyNavigation, LoadingContainer},

  mixins: [Errors],

  model: {
    prop: 'company',
    event: 'company-updated'
  },

  props: {
    company: {
      required: true
    },

    portalCompanyId: {
      required: true
    }
  },

  data() {
    return {
      portalCompany: null,
      countries: null,
      users: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.loading = true

      Promise.all([
        http.get('/api/v2/portal-companies/' + this.portalCompanyId),
        http.get('/api/v2/countries'),
        http.get('/api/v2/users'),
      ]).then(responses => {
        this.portalCompany = responses[0].data.data

        this.countries = responses[1].data.data

        this.users = responses[2].data.data

        this.loading = false
      })
    }
  }
}
</script>
